const MATERIAL_SYMBOLS_TRANSFORM = 'scale(0.025) translate(0 960)';
const PERSON_PATH =
  'M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z';

export default {
  call: [
    {
      d:
        'M795-120q-116 0-236.5-56T335-335Q232-438 176-558.5T120-795q0-19 13-32t32-13h140q14 0 24 10t14 25l27 126q2 14-.5 25.5T359-634L259-533q26 44 55 82t64 72q37 38 78 69.5t86 55.5l95-98q10-11 23-15t26-2l119 26q15 4 25 16t10 27v135q0 19-13 32t-32 13Z',
      transform: MATERIAL_SYMBOLS_TRANSFORM,
    },
  ],
  whatsapp: [
    {
      d:
        'M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2Z',
    },
    {
      d:
        'M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z',
      cutout: true,
    },
  ],
  online_meeting: [
    {
      d:
        'M21 2C22.05 2 22.92 2.81 23 3.85L23 4V16C23 17.05 22.18 17.92 21.15 18L21 18H14V20H16V22H8V20H10V18H3C1.95 18 1.08 17.18 1 16.15L1 16V4C1 2.94 1.81 2.08 2.85 2L3 2H21M21 4H3V16H21V4M12 11C14.21 11 16 11.9 16 13V14H8V13C8 11.9 9.79 11 12 11M12 6C13.11 6 14 6.9 14 8S13.11 10 12 10 10 9.11 10 8 10.9 6 12 6Z',
      transform: 'scale(0.82)',
    },
    {
      d: PERSON_PATH,
      transform: 'translate(10.6 9.6) scale(0.62)',
      outline: true,
    },
  ],
  in_person_meeting: [
    {
      d: PERSON_PATH,
      transform: 'translate(-1 8.2) scale(0.56)',
    },
    {
      d: PERSON_PATH,
      transform: 'translate(11.6 8.2) scale(0.56)',
    },
    {
      d:
        'M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4C22,2.89 21.1,2 20,2Z',
      transform: 'translate(7.4 0.6) scale(0.4)',
    },
    {
      d: 'M1 20.2h22v1.6H1z',
    },
  ],
  store_visit: [
    {
      d:
        'M5.06 3C4.63 3 4.22 3.14 3.84 3.42C3.46 3.7 3.24 4.06 3.14 4.5L2.11 8.91C1.86 10 2.06 10.92 2.69 11.73C2.81 11.85 2.93 11.97 3.04 12.07C3.63 12.64 4.28 13 5.22 13C6.16 13 6.91 12.59 7.47 12.05C8.1 12.67 8.86 13 9.8 13C10.64 13 11.44 12.63 12 12.07C12.68 12.7 13.45 13 14.3 13C15.17 13 15.91 12.67 16.54 12.05C17.11 12.62 17.86 13 18.81 13C19.76 13 20.43 12.65 21 12.06C21.09 11.97 21.18 11.87 21.28 11.77C21.94 10.95 22.14 10 21.89 8.91L20.86 4.5C20.73 4.06 20.5 3.7 20.13 3.42C19.77 3.14 19.38 3 18.94 3M18.89 4.97L19.97 9.38C20.06 9.81 19.97 10.2 19.69 10.55C19.44 10.86 19.13 11 18.75 11C18.44 11 18.17 10.9 17.95 10.66C17.73 10.43 17.61 10.16 17.58 9.84L16.97 5M5.06 5H7.03L6.42 9.84C6.3 10.63 5.91 11 5.25 11C4.84 11 4.53 10.86 4.31 10.55C4.03 10.2 3.94 9.81 4.03 9.38M9.05 5H11V9.7C11 10.05 10.89 10.35 10.64 10.62C10.39 10.88 10.08 11 9.7 11C9.36 11 9.07 10.88 8.84 10.59C8.61 10.3 8.5 10 8.5 9.66V9.5M13 5H14.95L15.5 9.5C15.58 9.92 15.5 10.27 15.21 10.57C14.95 10.87 14.61 11 14.2 11C13.89 11 13.61 10.88 13.36 10.62C13.11 10.35 13 10.05 13 9.7',
    },
    {
      d:
        'M3 14.03V19C3 20.11 3.89 21 5 21H19C20.1 21 21 20.11 21 19V14.05C20.45 14.63 19.75 14.96 19 15C18 15.03 17.25 14.74 16.54 14.05C15.94 14.65 15.14 15 14.3 15C13.4 15 12.6 14.64 12 14.07C11.43 14.64 10.65 15 9.78 15C8.87 15 8.07 14.65 7.47 14.05C6.89 14.64 6.1 15 5.23 15C4.33 15 3.66 14.65 3 14.03Z',
    },
    {
      d: 'M5.5 16.2h4v4.8h-4z',
      cutout: true,
    },
    {
      d: 'M12 16.2h6.5v3h-6.5z',
      cutout: true,
    },
  ],
  test_drive: [
    {
      d:
        'M13,19.92C14.8,19.7 16.35,18.95 17.65,17.65C18.95,16.35 19.7,14.8 19.92,13H16.92C16.7,14 16.24,14.84 15.54,15.54C14.84,16.24 14,16.7 13,16.92V19.92M10,8H14L17,11H19.92C19.67,9.05 18.79,7.38 17.27,6C15.76,4.66 14,4 12,4C10,4 8.24,4.66 6.73,6C5.21,7.38 4.33,9.05 4.08,11H7L10,8M11,19.92V16.92C10,16.7 9.16,16.24 8.46,15.54C7.76,14.84 7.3,14 7.08,13H4.08C4.3,14.77 5.05,16.3 6.35,17.6C7.65,18.9 9.2,19.67 11,19.92M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z',
      transform: 'translate(0.2 3.6) scale(0.84)',
    },
    {
      d:
        'M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z',
      transform: 'translate(12.4 0.2) scale(0.5)',
      outline: true,
    },
  ],
  email: [
    {
      d:
        'M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm340-308q5 0 8.5-1.5t7.5-3.5l314-205q5-3 7.5-8t2.5-11q0-13-11.5-20.5t-23.5.5L480-522 176-717q-12-8-24-1t-12 20q0 6 3 11.5t7 8.5l314 205q4 2 7.5 3.5t8.5 1.5Z',
      transform: MATERIAL_SYMBOLS_TRANSFORM,
    },
  ],
  other: [
    {
      d:
        'M658-487 487-658q-5-5-7-10.13-2-5.14-2-11 0-5.87 2-10.87 2-5 7-10l171-171q5-5 10.13-7 5.14-2 11-2 5.87 0 10.87 2 5 2 10 7l171 171q5 5 7 10.13 2 5.14 2 11 0 5.87-2 10.87-2 5-7 10L700-487q-5 5-10.13 7-5.14 2-11 2-5.87 0-10.87-2-5-2-10-7Zm-538-81v-241q0-12.75 8.63-21.38Q137.25-839 150-839h241q12.75 0 21.38 8.62Q421-821.75 421-809v241q0 12.75-8.62 21.37Q403.75-538 391-538H150q-12.75 0-21.37-8.63Q120-555.25 120-568Zm418 418v-241q0-12.75 8.63-21.38Q555.25-421 568-421h241q12.75 0 21.38 8.62Q839-403.75 839-391v241q0 12.75-8.62 21.37Q821.75-120 809-120H568q-12.75 0-21.37-8.63Q538-137.25 538-150Zm-418 0v-241q0-12.75 8.63-21.38Q137.25-421 150-421h241q12.75 0 21.38 8.62Q421-403.75 421-391v241q0 12.75-8.62 21.37Q403.75-120 391-120H150q-12.75 0-21.37-8.63Q120-137.25 120-150Z',
      transform: MATERIAL_SYMBOLS_TRANSFORM,
    },
  ],
};
